function path(root: string, sublink: string) {
  return `${root}${sublink}`;
}

const ROOTS_APP = `/${process.env.PUBLIC_URL}`;
const ROOTS_APP_WITHOUT_BAR = `${process.env.PUBLIC_URL}`;

export const PATH_APP = {
  root: ROOTS_APP,
  root_without_bar: ROOTS_APP_WITHOUT_BAR,
  agendamentoTransportadora: `${ROOTS_APP_WITHOUT_BAR}/agendamentoTransportadora`
};

export const PATH_AGENDAMENTOS_APP = {
  selecionarMatricula: path(PATH_APP.agendamentoTransportadora, '/selecionarMatricula'),
  contratos: path(PATH_APP.agendamentoTransportadora, '/contratos'),
  agendamento: path(PATH_APP.agendamentoTransportadora, '/agendamento'),
  relatorio: path(PATH_APP.agendamentoTransportadora, '/relatorio'),
  cadastroVeiculo: path(PATH_APP.agendamentoTransportadora, '/cadastroVeiculo'),
  solicitacaoPagamento: path(PATH_APP.agendamentoTransportadora, '/solicitacaoPagamento'),
  adicionarAgendamento: path(
    PATH_APP.agendamentoTransportadora,
    '/contrato/agendar/:matricula/:contrato/:local/:tipoFrete'
  ),
  historicoPagamento: path(
    PATH_APP.agendamentoTransportadora,
    '/solicitacao/pagamento/:matricula/:contrato/:nota/:serie'
  )
};
